export default "__VITE_ASSET__DIPf3XVu__"